"use client"

import "bootstrap/dist/css/bootstrap.css";
import "@soprisapps/schoolblocks/src/scss/_error.scss";
import '@soprisapps/schoolblocks/src/scss/_reset.scss';
import ErrorPage from "@soprisapps/components/pages/ErrorPage";

export default function Error({error, reset}) {
    return <ErrorPage />
}